<!-- HEADER WRAPPER -->
<div class="site-header__inner sticky z-[999] bg-white" id="menu-primary">

    <!-- Branding / Logo -->
    <div class="site-header__branding">
        <a href="https://purso.fi/" class="site-header__title" rel="home" itemprop="headline">
            <noscript>
                <img
                        src="https://purso.fi/wp-content/uploads/2024/10/pursologo24.svg"
                        width="1500"
                        height="500"
                        alt="Purso Logo"
                        sizes="100vw"
                />
            </noscript>
            <img
                    src="https://purso.fi/wp-content/uploads/2024/10/pursologo24.svg"
                    width="1500"
                    height="500"
                    alt="Purso Logo"
                    class="lazyload--fast"
                    sizes="100vw"
            />
        </a>
    </div>

    <!-- Hamburger / Menu Toggle Button -->
    <button class="js-menu-toggle menu-toggle" (click)="toggleMenu()">
        <svg
                class="menu-toggle__svg icon text-primary-500 fill-current"
                aria-hidden="true"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 100 100"
        >
            <g
                    class="hamburger transition-opacity duration-300 ease-in-out"
                    [ngClass]="{'opacity-100': !menuOpen, 'opacity-0 pointer-events-none': menuOpen}"
            >
                <path d="M5 13h90v14H5z"></path>
                <path d="M5 43h90v14H5z"></path>
                <path d="M5 73h90v14H5z"></path>
            </g>
            <g
                    class="close transition-opacity duration-300 ease-in-out"
                    [ngClass]="{'opacity-100': menuOpen, 'opacity-0 pointer-events-none': !menuOpen}"
            >
                <path
                        d="M15 15L85 85"
                        stroke="currentColor"
                        stroke-width="14"
                        stroke-linecap="round"
                ></path>
                <path
                        d="M85 15L15 85"
                        stroke="currentColor"
                        stroke-width="14"
                        stroke-linecap="round"
                ></path>
            </g>
        </svg>
        <!-- Avaus/sulku-tekstit käännettävillä avaimilla -->
        <span class="menu-toggle__label-open">{{ "HEADER.OPEN_MENU" | translate }}</span>
        <span class="menu-toggle__label-close">{{ "HEADER.CLOSE_MENU" | translate }}</span>
    </button>

    <!-- DESKTOP MENU WRAPPER -->
    <div class="site-header__menus">
        <div class="site-header__main desktop-menu">
            <nav
                    class="js-navigation primary-navigation header-navigation"
                    aria-label="Päävalikko"
                    itemscope
                    itemtype="https://schema.org/SiteNavigationElement"
            >
                <!-- UL, jossa ID ja class samoin kuin alkuperäisessä koodissa -->
                <ul id="menu-paavalikko-fi-1" class="primary-navigation__items">
                    <!-- @for-luuppi: generoi päävalikon kohdat -->
                    @for (menuItem of navItems; track menuItem.label) {
                        <li>
              <span class="menu-item__link">
                <a [href]="menuItem.link">{{ menuItem.label | translate }}</a>
                  <!-- Näytetään nappi + alavalikko vain jos .children on olemassa -->
                  @if (menuItem.children?.length) {
                      <button class="menu-item__caret js-menu-caret" (click)="menuItem.expanded = !menuItem.expanded">
                    <svg aria-hidden="true" class="icon icon-angle-down-solid">
                      <!--<use xlink:href="https://purso.fi/wp-content/themes/purso/dist/sprite/sprite.svg#icon-angle-down-solid"></use>-->
                    </svg>
                    <span class="menu-item__caret__text-open">{{ "HEADER.OPEN_SUBMENU" | translate }}</span>
                    <span class="menu-item__caret__text-close">{{ "HEADER.CLOSE_SUBMENU" | translate }}</span>
                  </button>
                  }
              </span>

                            <!-- Alavalikko -->
                            @if (menuItem.children?.length) {
                                <ul class="sub-menu" [attr.aria-hidden]="!menuItem.expanded">
                                    @for (child of menuItem.children; track child.label) {
                                        <li class="relative">
                      <span class="menu-item__link">
                        <a [href]="child.link">{{ child.label | translate }}</a>
                          @if (child.children?.length) {
                              <button class="menu-item__caret js-menu-caret" (click)="child.expanded = !child.expanded">
                            <svg aria-hidden="true" class="icon icon-angle-down-solid">
                              <!--<use xlink:href="https://purso.fi/wp-content/themes/purso/dist/sprite/sprite.svg#icon-angle-down-solid"></use>-->
                            </svg>
                            <span class="menu-item__caret__text-open">{{ "HEADER.OPEN_SUBMENU" | translate }}</span>
                            <span class="menu-item__caret__text-close">{{ "HEADER.CLOSE_SUBMENU" | translate }}</span>
                          </button>
                          }
                      </span>

                                            <!-- Alavalikon lapsi-lapsilista -->
                                            @if (child.children?.length) {
                                                <ul class="sub-menu" [attr.aria-hidden]="!child.expanded">
                                                    @for (subchild of child.children; track subchild.label) {
                                                        <li class="bg-primary-100">
                              <span class="menu-item__link">
                                <a [href]="subchild.link">{{ subchild.label | translate }}</a>
                              </span>
                                                        </li>
                                                    }
                                                </ul>
                                            }
                                        </li>
                                    }
                                </ul>
                            }
                        </li>
                    }
                </ul>
            </nav>
        </div>
    </div>
</div>

<!-- MOBILE MENU -->
<div
        class="mobile-menu absolute z-10 block md:hidden"
        aria-modal="true"
        tabindex="-1"
        role="dialog"
        [ngClass]="{'hidden': !menuOpen}"
>
    <!-- Nav-kontti, h-0 / h-[100vh] ja transition-luokat halutessa -->
    <div
            class="mobile-menu__nav z-20 transition-all duration-300 ease-in-out"
            [class.h-0]="!menuOpen"
            [class.h-[100vh]]="menuOpen"
            role="dialog"
    >


        <div class="mobile-menu__nav__inner">
            <nav
                    class="js-navigation primary-navigation header-navigation"
                    aria-label="Päävalikko"
                    itemscope
                    itemtype="https://schema.org/SiteNavigationElement"
            >
                <!-- Mobiili-valikon UL -->
                <ul id="menu-paavalikko-fi" class="primary-navigation__items">
                    @for (menuItem of navItems; track menuItem.label) {
                        <li>
              <span class="menu-item__link">
                <a [href]="menuItem.link">{{ menuItem.label | translate }}</a>
                  @if (menuItem.children?.length) {
                      <button class="menu-item__caret js-menu-caret" (click)="menuItem.expanded = !menuItem.expanded">
                    <svg aria-hidden="true" class="icon icon-angle-down-solid">
                      <!--<use xlink:href="https://purso.fi/wp-content/themes/purso/dist/sprite/sprite.svg#icon-angle-down-solid"></use>-->
                    </svg>
                    <span class="menu-item__caret__text-open">{{ "HEADER.OPEN_SUBMENU" | translate }}</span>
                    <span class="menu-item__caret__text-close">{{ "HEADER.CLOSE_SUBMENU" | translate }}</span>
                  </button>
                  }
              </span>

                            @if (menuItem.children?.length) {
                                <ul class="sub-menu" [attr.aria-hidden]="!menuItem.expanded">
                                    @for (child of menuItem.children; track child.label) {
                                        <li class="bg-primary-100">
                      <span class="menu-item__link">
                        <a [href]="child.link">{{ child.label | translate }}</a>
                          @if (child.children?.length) {
                              <button class="menu-item__caret js-menu-caret" (click)="child.expanded = !child.expanded">
                            <svg aria-hidden="true" class="icon icon-angle-down-solid">
                              <!--<use xlink:href="https://purso.fi/wp-content/themes/purso/dist/sprite/sprite.svg#icon-angle-down-solid"></use>-->
                            </svg>
                            <span class="menu-item__caret__text-open">{{ "HEADER.OPEN_SUBMENU" | translate }}</span>
                            <span class="menu-item__caret__text-close">{{ "HEADER.CLOSE_SUBMENU" | translate }}</span>
                          </button>
                          }
                      </span>

                                            @if (child.children?.length) {
                                                <ul class="sub-menu" [attr.aria-hidden]="!child.expanded">
                                                    @for (subchild of child.children; track subchild.label) {
                                                        <li>
                              <span class="menu-item__link">
                                <a [href]="subchild.link">{{ subchild.label | translate }}</a>
                              </span>
                                                        </li>
                                                    }
                                                </ul>
                                            }
                                        </li>
                                    }
                                </ul>
                            }
                        </li>
                    }
                </ul>
            </nav>


        </div>

        <ul id="menu-ylavalikko-fi" class="primary-navigation__items row no-gutters justify-content-between">
            <!--<li id="menu-item-3967" class="menu-item menu-item-type-custom menu-item-object-custom current-menu-ancestor current-menu-parent menu-item-has-children menu-item-3967" aria-expanded="false">
                <span class="menu-item__link"><a href="#">Purso Group</a><button class="menu-item__caret js-menu-caret">

                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none"
                         class="w-5 h-5 stroke-current [stroke-width:3]" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M19 9l-7 7-7-7" />
                            </svg>


    <span class="menu-item__caret__text-open">Avaa alavalikko</span><span class="menu-item__caret__text-close">Sulje alavalikko</span></button></span>
            <ul class="sub-menu" aria-hidden="true">
                <li id="menu-item-3968" class="strong menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-29 current_page_item menu-item-3968"><span class="menu-item__link"><a href="https://purso.fi/" aria-current="page">Purso Oy</a></span></li>
                <li id="menu-item-8013" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-8013"><span class="menu-item__link"><a href="https://pursoalucool.fi/">Purso AluCool Oy</a></span></li>
                <li id="menu-item-3969" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-3969"><span class="menu-item__link"><a href="https://www.nedal.com/">Nedal Aluminium</a></span></li>
            </ul>
        </li>-->
            <li id="menu-item-3970" class=""  aria-expanded="true"><span (click)="langMenuOpen=!langMenuOpen" class="">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-8 0 512 512" fill="currentColor"
                     class="w-4 h-4 text-white mr-2" aria-hidden="true">
                            <path d="M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"/>
                </svg><a class="font-bold !text-white uppercase tracking-widest leading-[33px] focus:outline-none" href="#pll_switcher">

                {{ currentLanguage() | translate }}</a>
                <button class="menu-item__caret js-menu-caret">

    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none"
         class="w-5 h-5 stroke-current [stroke-width:3]" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M19 9l-7 7-7-7" />
                            </svg>


    <span class="menu-item__caret__text-open">Avaa alavalikko</span><span class="menu-item__caret__text-close">Sulje alavalikko</span></button></span>
                <ul class="sub-menu bg-primary overflow-hidden" [style.background]="'none'" [class.h-0]="!langMenuOpen" [class.h-32]="langMenuOpen" aria-hidden="false">
                    <li  class="bg-primary !text-white"><span class="menu-item__link"><a class="!text-white" (click)="translateService.use('fi')" hreflang="fi" lang="fi">{{"fi" | translate}}</a></span></li>
                    <li  class="bg-primary !text-white"><span class="menu-item__link"><a class="!text-white" (click)="translateService.use('fi')" hreflang="en-GB" lang="en-GB">{{"en" | translate}}</a></span></li>
                </ul>
            </li>

            <li class="">
                <span  class="">
                    <a class="font-bold !text-white uppercase tracking-widest leading-[33px] focus:outline-none" href="./login">
                        {{ "GLOBAL.LOGIN" | translate }}
                    </a>
                </span>
            </li>

            <li class="">
                <span  class="">
                    <a class="font-bold !text-white uppercase tracking-widest leading-[33px] focus:outline-none" href="#">
                        {{ "GLOBAL.REGISTER" | translate }}
                    </a>
                </span>
            </li>
        </ul>
    </div>

    <!-- Mobiili-valikon overlay -->
    <div
            class="mobile-menu__overlay z-10 transition-opacity duration-1000"
            [ngClass]="{'opacity-0 pointer-events-none': !menuOpen, 'opacity-100': menuOpen}"
            data-a11y-dialog-hide
            tabindex="-1"
    ></div>
</div>





